import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AdminTicketsService } from '../../core/services/admin-tickets.service';
import { AdminUsersService } from '../../core/services/admin-users.service';
import { SupportTicket, AdminUser } from '../../core/models/admin.models';
import { ModalComponent } from '../../shared/components/ui/modal/modal.component';
import { TicketFormComponent } from '../ticket-form/ticket-form.component';

@Component({
  selector: 'app-tickets-list',
  standalone: true,
  imports: [CommonModule, FormsModule, ModalComponent, TicketFormComponent],
  templateUrl: './tickets-list.component.html'
})
export class TicketsListComponent implements OnInit {
  tickets: SupportTicket[] = [];
  users: AdminUser[] = [];
  isLoading = false;
  errorMessage = '';
  updatingTicketId: number | null = null;
  
  isModalOpen = false;

  constructor(
    private ticketsService: AdminTicketsService,
    private usersService: AdminUsersService
  ) {}

  ngOnInit() {
    this.loadTickets();
    this.loadUsers();
  }

  loadUsers() {
    this.usersService.getUsers().subscribe({
      next: (res) => {
        this.users = Array.isArray(res) ? res : (res as any).data ?? [];
      },
      error: (err) => console.error('Failed to load users', err)
    });
  }

  loadTickets() {
    this.isLoading = true;
    this.errorMessage = '';

    this.ticketsService.getTickets().subscribe({
      next: (res) => {
        this.tickets = Array.isArray(res) ? res : (res as any).data ?? [];
        this.isLoading = false;
      },
      error: (err) => {
        this.errorMessage = err?.error?.message ?? 'Failed to load tickets.';
        this.isLoading = false;
      }
    });
  }

  openCreateModal() {
    this.isModalOpen = true;
  }

  handleSave(data: Partial<SupportTicket>) {
    this.ticketsService.createTicket(data).subscribe({
      next: () => {
        this.isModalOpen = false;
        this.loadTickets();
      },
      error: (err) => alert(err?.error?.message ?? 'Failed to create ticket.')
    });
  }

  updateStatus(ticket: SupportTicket, newStatus: string) {
    this.updatingTicketId = ticket.id;
    this.ticketsService.updateTicketStatus(ticket.id, newStatus).subscribe({
      next: () => {
        ticket.status = newStatus as any;
        this.updatingTicketId = null;
      },
      error: (err) => {
        alert(err?.error?.message ?? 'Failed to update ticket status.');
        this.updatingTicketId = null;
      }
    });
  }

  getBadgeColorClass(status: string): string {
    switch(status) {
      case 'open': return 'bg-yellow-100 text-yellow-800';
      case 'in_progress': return 'bg-blue-100 text-blue-800';
      case 'resolved': return 'bg-green-100 text-green-800';
      case 'closed': return 'bg-gray-100 text-gray-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  }

  getPriorityClass(priority: string): string {
    switch(priority) {
      case 'high': return 'text-red-600 font-semibold';
      case 'medium': return 'text-orange-500 font-semibold';
      case 'low': return 'text-gray-500 font-medium';
      default: return 'text-gray-500';
    }
  }
}
